module.exports = __webpack_public_path__ + "media/college_jobs_internships/jobs_promo01-28d7d4cf.png";